export default {
    isAway: 'Temporarily Away',
    isBroadcasting: 'Broadcasting',
    isInClubShow: 'Club Show',
    isInGroupShow: 'Group Show',
    isInPrivateShow: 'Private Show',
    isInTruePrivateShow: 'TruePrivate Show',
    isNotBroadcasting: 'Not Broadcasting',
    isOffline: 'Offline',
}
